"use client";
import React from "react";
import { EntraSignInPanel } from "@/components/auth/EntraSignInPanel";

export const SignInForm = ({ onToggleSignUp }: { onToggleSignUp: () => void }) => {
    void onToggleSignUp;
    return <EntraSignInPanel mode="signin" />;
};
